import faceService from "@/services/face.service.js"

export const Faces = {
	namespaced : true,
	state :{
		list: [],
		listPage: [],
	},
	getters:{
		getListFaces : (state)=> {
	        return state.list;
	    },
	    getList : (state)=> {
	        return state.listPage;
	    },
	},
	actions:{
		getList({commit}){
			// console.log("LIST ", faceService)
			faceService.getListFor(1).then(res=>{
				// console.log("Finish get list for face ", res)
				commit("setList",res)
			}).catch(erro=>{
				console.warn("Error get list ListDetails ", error)
			});
		},
		searchFace({commit},params){
			// console.log("LIST ", params)
			return faceService.getList(params.page, params).then(res=>{
				// console.log("Finish get list for face ", res)
				// commit("setListPage",res)
				return Promise.resolve(res);
			}).catch(erro=>{
				console.warn("Error get list Details ", error)
				return Promise.reject(error);

			});
		},

	},
	mutations:{
		setList(state, list) {
      		state.list = list;
	    },
	    setList(state, list) {
      		state.listPage = list;
	    },
	    
	},
	
}